import { render, staticRenderFns } from "./reset-ask-dialog.vue?vue&type=template&id=106bbf35&scoped=true"
import script from "./reset-ask-dialog.vue?vue&type=script&lang=js"
export * from "./reset-ask-dialog.vue?vue&type=script&lang=js"
import style0 from "./reset-ask-dialog.vue?vue&type=style&index=0&id=106bbf35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106bbf35",
  null
  
)

export default component.exports